import React from 'react'
import currency from 'currency.js'
import { type WebProduct } from '../../common/types/webshop.types';
import { formatCurrency } from '../../common/js/currency-utility';
import { useTranslation } from 'react-i18next';

type Props = {
    onSelect: Function,
    selected: string,
    monthlyVariant: WebProduct,
    annualVariant: WebProduct,
    currencyIso: string
}

export default function SubscriptionStoreSelect(props: Props) {
    const {onSelect, selected, monthlyVariant, annualVariant, currencyIso} = props;
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        onSelect(event);
    }
    const { t } = useTranslation(['checkout', 'common'])

    const monthlyClass = selected == 'New Monthly Subscription' ? 'subscription-option selected' : 'subscription-option';
    const annualClass = selected == 'New Annual Subscription' ? 'subscription-option selected' : 'subscription-option';

    let monthly;
    let annual;
    let annualMonthly;
    if (annualVariant){
        const annualFloat = currency(annualVariant.prices[currencyIso]);
        const annualMonthlyFloat = currency(annualFloat).divide(12);
        annual = formatCurrency(annualFloat, currencyIso);
        annualMonthly = formatCurrency(annualMonthlyFloat, currencyIso)
    }
    if (monthlyVariant){
        const monthlyFloat = currency(monthlyVariant.prices[currencyIso]);
        monthly = formatCurrency(monthlyFloat, currencyIso);
    }



    return (
        <div className="row" style={{paddingTop: '32px', paddingBottom: '32px'}}>
            <div className="col-xl-6 col-12" style={{paddingLeft: '24px', paddingRight: '24px'}}>
                <div data-name="New Annual Subscription" className={annualClass} onClick={handleClick}>
                    <span><strong>{t('purchase.bestValue')}!</strong></span><br/>
                    <span className="title">{t('purchase.subTypes.annualSubscription')}</span><br/>
                    {annualVariant && (
                        <>
                            <span className='price'>{annualMonthly} /{t('purchase.monthAbbr')}<br /></span>
                            <span className='priceSubtitle'>({t('billedAnnually', {amount: annual})})</span>
                        </>
                    )}
                </div>
            </div>
            <div className="col-xl-6 col-12 subscription-select-monthly" style={{paddingLeft: '24px', paddingRight: '24px'}}>
                <div data-name="New Monthly Subscription" className={monthlyClass} onClick={handleClick}>
                    <span>Low Monthly Cost!</span><br />
                    <span className="title">Monthly Subscription</span><br />
                    {monthlyVariant && (
                        <>
                            <span className='price'>{monthly} /mo<br/></span>
                            <span className='priceSubtitle'>&nbsp;</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}